import React from "react";
import { withStyles, Avatar } from "@material-ui/core";
import appConstants from "../../../../../../../appConstants";

const colors = {
  avatarColor: "#444444",
  avatarBackground: "#F0F0F0",
  avatarBorderColor: "#8493A3"
};
const styles = (theme) => ({
  container: {
    display: "flex",
    alignItems: "center",
    float: "right",
    wordBreak: "break-all",
    textAlign: "left",
  },
  driverStatusLabel: {
    paddingLeft: "5px",
  },
  avatar: {
    color: colors.avatarColor,
    backgroundColor: "transparent",
    border: `1px solid ${colors.avatarBorderColor}`,
    alignSelf: "flex-start",
    width: 14,
    height: 14,
    fontSize: 10,
  },
  pickupStyle: {
    "&$avatar": {
      borderRadius: 0,
    },
  },
  deliveryStyle: {},
});

const NextStop = ({ classes, nextStopDetails }) => {
  const iconStyle =
    nextStopDetails.stopType === appConstants.STOP_TYPE.Pickup
      ? classes.pickupStyle
      : classes.deliveryStyle;
  return (
    <div className={classes.container}>
      <Avatar className={`${classes.avatar} ${iconStyle} tableCellName`}>
        {nextStopDetails.stopSequence}
      </Avatar>
      <div className={classes.driverStatusLabel}>
        {nextStopDetails.stopName}
      </div>
    </div>
  );
};

export default withStyles(styles)(NextStop);
